import { Fragment } from 'react';

import { VSpacing } from '@hh.ru/magritte-ui';
import { TranslatedComponent } from 'bloko/common/hooks/useTranslations';

import useGroupedMessages from 'src/components/ResumeView/useGroupedMessages';
import translation from 'src/components/translation';
import { useSelector } from 'src/hooks/useSelector';

import CollapseCollection from 'src/components/ResumeCard/Body/Collapse/Collection';
import Field from 'src/components/ResumeCard/Body/Field';
import MessageGroup from 'src/components/ResumeCard/Body/MessageGroup';

import styles from './pinned-messages.less';

const TrlKeys = {
    title: 'resume.search.field.controlQuestions',
};

const PinnedMessages: TranslatedComponent<{ chatId?: number }> = ({ chatId, trls }) => {
    const pinnedChatMessages = useSelector(
        (state) => chatId && state.candidatesList?.chatsByIds?.chats[`${chatId}`]?.pinnedMessagesByChatId
    );
    const groupedMessages = useGroupedMessages(pinnedChatMessages || []);

    if (!groupedMessages.length) {
        return null;
    }
    return (
        <Field title={trls[TrlKeys.title]} dataQaName="messages">
            <CollapseCollection
                collection={groupedMessages}
                renderItem={(messagesGroup, index) => (
                    <Fragment key={index}>
                        {index !== 0 && <VSpacing default={8} />}
                        <div className={styles.pinnedMessage}>
                            <MessageGroup messagesGroup={messagesGroup} />
                        </div>
                    </Fragment>
                )}
                dataQa="messages"
            />
        </Field>
    );
};

export default translation(PinnedMessages);
